import { useMutation } from "@apollo/client";
import { isAfter } from "date-fns";
// TODO: any styles needed really ought to be applied by the toast extras system but for now this is fine
import gql from "graphql-tag";
import mixpanel from "mixpanel-browser";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  MarkMarketingPromptAsReadMutation,
  MarkMarketingPromptAsReadMutationVariables,
} from "../../../../../__generated__/graphql";
import Calendar from "../../../../../dashboard/src/assets/images/EmptyStateAndUpsell/calendar.svg";
import { useToast } from "../../../../../shared/components/design-system/Toaster/context";
import useSelf from "../../../hooks/useSelf";
import { logToSentry } from "../../design-system/GenericError";
import NotificationAlert from "../../design-system/NotificationAlert/NotificationAlert";

// These could be passed in as props but there's really no need, we only ever make one of these components.
const featureId = "cop-june-2026";
// Date format here is (year, month - 1, date):
const showUntil = new Date(2026, 5, 2);
// Configure the body of the alert by editing the component.
let shown = false;

const MARK_MARKETING_PROMPT_AS_READ = gql`
  mutation markMarketingPromptAsRead($featureId: String!) {
    markFeatureAnnouncementAsRead(feature: $featureId) {
      id
      unreadFeatureAnnouncements
    }
  }
`;

export default function useExtraMarketingPrompt() {
  const self = useSelf();
  const toast = useToast();
  const navigate = useNavigate();

  const [clearPrompt] = useMutation<MarkMarketingPromptAsReadMutation, MarkMarketingPromptAsReadMutationVariables>(
    MARK_MARKETING_PROMPT_AS_READ,
    { variables: { featureId } },
  );

  useEffect(() => {
    if (shown || !self.unreadFeatureAnnouncements.includes(featureId) || isAfter(new Date(), showUntil)) return;
    shown = true;
    const toastId = toast.showExtra(ExtraMarketingPrompt, {
      onClose: () => {
        clearPrompt().catch((error) => {
          console.error(error);
          logToSentry(error);
        });
        toast.removeExtra(toastId);
        mixpanel.track("Dismissed the marketing prompt call to action", { featureId });
      },
      onRegister: () => {
        clearPrompt().catch((error) => {
          console.error(error);
          logToSentry(error);
        });
        toast.removeExtra(toastId);
        mixpanel.track("Marketing prompt accepted", { featureId });
        window.open("https://www.tickettailor.com/events/cultureshift/2127357", "_blank");
      },
    });
  }, [clearPrompt, self.unreadFeatureAnnouncements, toast, navigate]);
}

function ExtraMarketingPrompt({ onClose, onRegister }: { onClose: () => void; onRegister: () => void }) {
  return (
    <NotificationAlert
      title="Community of Practice"
      icon={Calendar}
      actions={[
        {
          label: "Dismiss",
          onClick: onClose,
        },
        {
          label: "Register",
          variant: "primary",
          onClick: onRegister,
        },
      ]}
    >
      <p>Join us in Birmingham for our CoP featuring a Refuge session on digital abuse</p>
    </NotificationAlert>
  );
}
